import { Pagination, Stack, TextField, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface PaginationControlsProps {
  currentPage: number
  totalPages: number
  pageNumberInput: string
  onPageChange: (page: number) => void
  onPageNumberInputChange: (value: string) => void
  onPageNumberSubmit: () => void
}

export const PaginationControls = ({
  currentPage,
  totalPages,
  pageNumberInput,
  onPageChange,
  onPageNumberInputChange,
  onPageNumberSubmit,
}: PaginationControlsProps) => {
  const { t } = useTranslation()

  return (
    <Stack alignItems="center" direction="row" spacing={2}>
      <Pagination
        showFirstButton
        showLastButton
        count={totalPages}
        page={currentPage}
        size="small"
        onChange={(event, page) => onPageChange(page)}
      />

      <Typography variant="body2">|</Typography>

      <TextField
        placeholder={t('resources.ramp_curves.entries.jump_to_page')}
        size="small"
        slotProps={{
          htmlInput: {
            min: 1,
            max: totalPages,
            style: { textAlign: 'center', backgroundColor: 'white' },
          },
        }}
        sx={{ width: 80 }}
        value={pageNumberInput}
        onChange={(e) => onPageNumberInputChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            e.stopPropagation()
            onPageNumberSubmit()
          }
        }}
      />
    </Stack>
  )
}
